export default "__VITE_ASSET__D3c2Z9wq__"